import { useCallback, useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchOAuthAccountJWTParams,
  selectOAuthAccountJWT,
  selectOAuthAccountJWTLoading,
  selectOAuthAccountJWTState,
  useFetchOAuthAccountJWTQuery,
  useLazyFetchOAuthAccountJWTQuery,
} from '../fetchOAuthAccountJWT';

export interface IUseOAuthAccountJWTQueryProps
  extends IFetchOAuthAccountJWTParams,
    IUseQueryProps {}

export const useOAuthAccountJWTQuery = ({
  skipFetching,
  totp,
}: IUseOAuthAccountJWTQueryProps) => {
  const params = useMemo(
    (): IFetchOAuthAccountJWTParams => ({ params: undefined, totp }),
    [totp],
  );

  useFetchOAuthAccountJWTQuery(getQueryParams({ params, skipFetching }));

  const [fetchLazy] = useLazyFetchOAuthAccountJWTQuery();

  const handleFetchOAuthAccountJWT = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const oAuthAccountJWT = useAppSelector(state =>
    selectOAuthAccountJWT(state, params),
  );

  const loading = useAppSelector(state =>
    selectOAuthAccountJWTLoading(state, params),
  );

  const state = useAppSelector(storeState =>
    selectOAuthAccountJWTState(storeState, params),
  );

  return {
    handleFetchOAuthAccountJWT,
    loading,
    oAuthAccountJWT,
    params,
    state,
  };
};
